/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Find_CoordinatorInputs */



/**
* | output |
* | --- |
* | "Find an official near you" |
*
* @param {Profile_Find_CoordinatorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_find_coordinator = /** @type {((inputs?: Profile_Find_CoordinatorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Find_CoordinatorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Trouver un officiel près de vous")
	if (locale === "es") return /** @type {LocalizedString} */ ("Encontrar un oficial cerca de ti")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Encontrar um oficial perto de você")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trova un ufficiale vicino a te")
	return /** @type {LocalizedString} */ ("Find an official near you")
});